export default {"src":"/_next/static/media/header_not_started.1f9b0185.svg","height":240,"width":240,"blurWidth":0,"blurHeight":0};